import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <section className="wrapper style1">
            <div className="container">
                <div id="content">
                    <article>
                        <header>
                            <h2>Página não encontrada</h2>
                            <p>Oops! A página que você está procurando não existe.</p>
                        </header>

                        <p>
                            Parece que a página que você está tentando acessar não foi encontrada.
                            Isso pode ter acontecido porque:
                        </p>

                        <ul>
                            <li>O link pode estar quebrado</li>
                            <li>A página pode ter sido movida</li>
                            <li>Você pode ter digitado o endereço incorretamente</li>
                        </ul>

                        <p>
                            <Link to="/" className="button">
                                Voltar para a página inicial
                            </Link>
                        </p>
                    </article>
                </div>
            </div>
        </section>
    );
};

export default NotFound;
